var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcurement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66634 3.99996H11.333M4.66634 7.33329H11.333M4.66634 10.6666H11.333M2.99967 0.666626H12.9997C13.9201 0.666626 14.6663 1.41282 14.6663 2.33329V14.6366C14.6663 15.8755 13.3625 16.6814 12.2543 16.1273L12.0784 16.0393C11.6092 15.8047 11.0569 15.8047 10.5877 16.0393L8.74503 16.9606C8.27582 17.1952 7.72353 17.1952 7.25432 16.9606L5.4117 16.0393C4.94248 15.8047 4.3902 15.8047 3.92099 16.0393L3.74503 16.1273C2.63686 16.6814 1.33301 15.8755 1.33301 14.6366V2.33329C1.33301 1.41282 2.0792 0.666626 2.99967 0.666626Z",
    stroke: "url(#paint0_linear_10415_1782)",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10415_1782",
    x1: -6.25032,
    y1: -8.49478,
    x2: 18.7874,
    y2: 10.8863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#299FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0202A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcurement);
export default __webpack_public_path__ + "static/media/procurement.69aa0cfd3963427023c601eff5abe9f3.svg";
export { ForwardRef as ReactComponent };